<template>
  <div class='h-outTabs'>
    <div id='sliceProfileTable' class='h100vh-140'>
      <SliceProfileMenu @methodEnum='methodEnum'></SliceProfileMenu>
      <SliceProfileTable ref="sliceProfileTable"></SliceProfileTable>
    </div>
  </div>
</template>
<script>
import SliceProfileMenu from './SliceProfileMenu';
import SliceProfileTable from './SliceProfileTable';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'SliceProfileList',
  components: {
    SliceProfileMenu,
    SliceProfileTable
  },
  data() {
    return {
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          this.$refs.sliceProfileTable.page.pageNo = "1";
          this.$refs.sliceProfileTable.getSliceProfileListData();
          break;
        case 'add':
          this.$refs.sliceProfileTable.addSliceProfilePage();
          break;      
        case 'delete':
          this.$refs.sliceProfileTable.deleteSliceProfilePage();
          break;      
        default:
      }
    }
  },
  mounted() {
  }
};
</script>
